import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faMars, faVenus, faCheck, faClose, faTrash } from '@fortawesome/free-solid-svg-icons';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'app-friends-card',
  standalone: true,
  imports: [RouterLink,FontAwesomeModule],
  templateUrl: './friends-card.component.html',
  styleUrl: './friends-card.component.css'
})
export class FriendsCardComponent {
  @Input() friend!:any;
  famale = faMars;
  fafemale = faVenus;
  friends:any;
  

}
